export default "__VITE_ASSET__000a0238__"